export default "__VITE_ASSET__suFIpBdC__"